import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { historyCanGoBack, pathFromLocation } from '../utils/navigation';

/**
 * Pop in-app history when we actually stacked a page (story, editor, login).
 * Fall back to `location.state.from` or a root tab — never leave the PWA
 * just because window.history.length > 1 (iOS always is).
 */
export function useSmartBack(fallback = '/') {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (historyCanGoBack()) {
      navigate(-1);
      return;
    }
    const from = location.state?.from;
    const here = pathFromLocation(location);
    if (typeof from === 'string' && from && from !== here) {
      navigate(from, { replace: true });
      return;
    }
    navigate(fallback, { replace: true });
  }, [fallback, location, navigate]);
}
